import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService } from './base-edit.service';
import { HttpService } from '../http.service';
import { NotificationService } from '../notification.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditCreateService<T, TEdit> extends BaseEditService<T, TEdit> {
  protected constructor(
    protected baseRoute: string,
    public name: string,
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(baseRoute, name, httpService, notificationService);
  }

  create(parentId?: string, parentId2?: string): Observable<TEdit> {
    return this.httpService.get<TEdit>(
      `${this.apiUrl}/Create${parentId ? `/${parentId}` : ''}${parentId2 ? `/${parentId2}` : ''}`,
    );
  }
}
